import React, { Component } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { KeyboardDatePicker } from "@material-ui/pickers";
import TBLRelatorio from "../../../components/TBLRelatorio";
import { getInfoFinanceiraEstabelecimento } from "../../../providers/EstabelecimentoProvider";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PDFRelatorioVenda from "../../../pdfs/PDFRelatorioVendas";
import { getUser } from "../../../services/Auth";
import { getPedidosByDateRange } from "../../../providers/PedidoProvider";

export default class RelatorioVenda extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInicio: null,
      dataFim: null,
      data: [],
      datas: [],
      pages: 1,
      page: 1,
      loading: false,
      limit: 10,
      dataPedido: null,
      estabelecimento: null,
      taxa_operacao: 0,
      faturamento: null,
      relatorioDisponivel: false,
      ticketMedio: 0,
    };
  }

  async componentDidMount() {
    const user = await getUser();
    if (user) {
      this.setState({ estabelecimento: user.estabelecimento });
    }
    const financeiro = await getInfoFinanceiraEstabelecimento();
    if (financeiro) {
      this.setState({ taxa_operacao: financeiro.taxa_operacao });
    }
  }

  formatFaturamento = (p, faturamento) => {
    const { taxa_operacao } = this.state;
    faturamento.total_vendas += 1;
    faturamento.total_faturado += p.valor_total;
    faturamento.subtotal_faturado += p.detalhes_pagamento.subtotal;
    if (p.detalhes_pagamento.subtotal >= faturamento.maior_venda) {
      faturamento.maior_venda = p.detalhes_pagamento.subtotal;
    }
    if (p.detalhes_pagamento.subtotal <= faturamento.menor_venda) {
      faturamento.menor_venda = p.detalhes_pagamento.subtotal;
    }
    if (
      p.detalhes_pagamento.frete &&
      p.metodo_pagamento.metodo === "pagamento_na_entrega"
    ) {
      faturamento.total_fretes += p.detalhes_pagamento.frete;
      faturamento.quantidade_fretes += 1;
    }
    if (p.metodo_pagamento.tipo === "dinheiro") {
      faturamento.total_fretes_dinheiro += p.detalhes_pagamento.frete;
      faturamento.quantidade_fretes_dinheiro += 1;
    } else {
      faturamento.total_fretes_cartao += p.detalhes_pagamento.frete;
      faturamento.quantidade_fretes_cartao += 1;
    }

    faturamento.total_estabelecimento =
      faturamento.subtotal_faturado * (1 - taxa_operacao);
    faturamento.total_ifeira = faturamento.subtotal_faturado * taxa_operacao;
    return faturamento;
  };

  calcularFaturamento = async () => {
    let pedidosSelecionados = [];
    const { dataInicio, dataFim } = this.state;
    this.setState({
      loading: true,
      relatorioDisponivel: false,
    });
    const data = await getPedidosByDateRange(dataInicio, dataFim);
    if (data) {
      const pedidos = data;
      let faturamento = {
        total_faturado: 0,
        subtotal_faturado: 0,
        total_vendas: 0,
        total_fretes: 0,
        total_estabelecimento: 0,
        total_ifeira: 0,
        maior_venda: 0,
        menor_venda: 999999999999,
        total_promocoes: 0,
        pedidos_cancelados: 0,
        quantidade_fretes: 0,
        fretes_ifeira: 0,
        total_fretes_cartao: 0,
        total_fretes_dinheiro: 0,
        quantidade_fretes_cartao: 0,
        quantidade_fretes_dinheiro: 0,
      };
      pedidos.forEach((p) => {
        const date = p.agendado ? new Date(p.dataAgendamento) : new Date(p.createdAt);
        if (p.status === "entregue" || p.status === "entrega_finalizada") {
          p.total_ifeira = parseFloat(
            p.detalhes_pagamento.subtotal * this.state.taxa_operacao,
          )
            .toFixed(2)
            .toString()
            .replace(".", ",");
          p.total_estabelecimento = parseFloat(
            p.detalhes_pagamento.subtotal * (1 - this.state.taxa_operacao),
          )
            .toFixed(2)
            .toString()
            .replace(".", ",");
          if (dataInicio && dataFim) {
            const dataInicioF = new Date(dataInicio);
            const dataFimF = new Date(dataFim);
            dataInicioF.setUTCHours(0);
            dataFimF.setUTCHours(23);
            if (
              dataInicioF.getTime() <= date.getTime() &&
              dataFimF.getTime() >= date.getTime()
            ) {
              faturamento = this.formatFaturamento(p, faturamento);
              if (p.status === "cancelado") {
                faturamento.pedidos_cancelados += 1;
              }
              pedidosSelecionados.push(p);
            }
          } else {
            faturamento = this.formatFaturamento(p, faturamento);
            if (p.status === "cancelado") {
              faturamento.pedidos_cancelados += 1;
            }
            pedidosSelecionados.push(p);
          }
        }
      });
      this.setState({
        data: pedidosSelecionados,
        faturamento,
        loading: false,
        relatorioDisponivel: true,
        ticketMedio: parseFloat(faturamento.total_faturado / faturamento.total_vendas)
          .toFixed(2)
          .toString()
          .replace(".", ","),
      });
    }
  };

  limparPeriodo = async () => {
    this.setState({
      loading: false,
      dataInicio: null,
      dataFim: null,
      entregadorSelecionado: null,
      totalFaturado: 0,
      relatorioDisponivel: false,
      faturamento: null,
    });
  };

  render() {
    const { dataInicio, dataFim } = this.state;
    return (
      <div>
        <Row>
          <Col md={6}>
            <br></br>
            <Row>
              <Col>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <p style={{ marginBottom: 0, fontWeight: "bold" }}>
                    Defina um período de vendas:{" "}
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-end",
                    }}
                  >
                    <p style={{ marginRight: 30 }}>De</p>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      margin="normal"
                      id="Data inicial"
                      label="Data de início"
                      value={dataInicio}
                      style={{ width: "60%" }}
                      maxDate={new Date()}
                      onChange={(d) => this.setState({ dataInicio: d })}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-end",
                    }}
                  >
                    <p style={{ marginRight: 30 }}>Até</p>
                    <KeyboardDatePicker
                      disableToolbar
                      disabled={!this.state.dataInicio}
                      variant="inline"
                      margin="normal"
                      id="date-picker-inline"
                      label="Data final"
                      minDate={this.state.dataInicio}
                      maxDate={new Date()}
                      value={dataFim}
                      style={{ width: "60%" }}
                      onChange={(d) => this.setState({ dataFim: d })}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      marginTop: 17,
                    }}
                  >
                    <Button
                      style={{ height: 35 }}
                      onClick={() => this.calcularFaturamento()}
                    >
                      Aplicar
                    </Button>
                    {dataInicio && dataFim ? (
                      <Button
                        variant="danger"
                        style={{ height: 35, marginLeft: 5 }}
                        onClick={() => this.limparPeriodo()}
                      >
                        Limpar
                      </Button>
                    ) : null}
                  </div>
                </div>
              </Col>
            </Row>
            <br />
            <Row style={{ marginLeft: 5, display: "flex", alignItems: "center" }}>
              <Col>
                <p>
                  <b>Ticket Médio:</b>{" "}
                  <p style={{ color: "#701b8c" }}>R$ {this.state.ticketMedio}</p>
                </p>
              </Col>
              <Col style={{ textAlign: "right" }}>
                {this.state.relatorioDisponivel ? (
                  <PDFDownloadLink
                    document={
                      <PDFRelatorioVenda
                        data={this.state.data}
                        estabelecimento={this.state.estabelecimento}
                        dataInicio={this.state.dataInicio}
                        dataFim={this.state.dataFim}
                        ticketMedio={this.state.ticketMedio}
                        faturamento={this.state.faturamento}
                      />
                    }
                    fileName={`relatorio-vendas-${new Date().toLocaleString()}.pdf`}
                    style={{
                      textDecoration: "none",
                      padding: "10px",
                      color: "white",
                      backgroundColor: "#701B8C",
                      border: "1px solid white",
                    }}
                  >
                    Emitir Relatório
                  </PDFDownloadLink>
                ) : null}
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <br></br>
            {this.state.faturamento ? (
              <div style={{ textAlign: "right" }}>
                <p style={{ fontWeight: "bold", fontSize: 14, color: "#3D434D" }}>
                  Total Geral Faturado:
                  <span style={{ fontSize: 14, color: "#701B8C" }}>
                    {"  R$ "}
                    {parseFloat(this.state.faturamento.total_faturado)
                      .toFixed(2)
                      .replace(".", ",")}
                  </span>
                </p>
                <p style={{ fontWeight: "bold", fontSize: 14, color: "#3D434D" }}>
                  Faturamento Estabelecimento (sem frete):
                  <span style={{ fontSize: 14, color: "#701B8C" }}>
                    {"  R$ "}
                    {parseFloat(this.state.faturamento.subtotal_faturado)
                      .toFixed(2)
                      .replace(".", ",")}
                  </span>
                </p>
                <p style={{ fontWeight: "bold", fontSize: 14, color: "#3D434D" }}>
                  % iFeira:
                  <span style={{ fontSize: 14, color: "#701B8C" }}>
                    {"  R$ "}
                    {parseFloat(this.state.faturamento.total_ifeira)
                      .toFixed(2)
                      .replace(".", ",")}
                  </span>
                </p>
                <p style={{ fontWeight: "bold", fontSize: 14, color: "#3D434D" }}>
                  Faturamento Fretes:
                  <span style={{ fontSize: 14, color: "#701B8C" }}>
                    {"  R$ "}
                    {parseFloat(this.state.faturamento.total_fretes)
                      .toFixed(2)
                      .replace(".", ",")}
                  </span>
                </p>
                <p style={{ fontWeight: "bold", fontSize: 14, color: "#3D434D" }}>
                  Saldo Final Estabelecimento:
                  <span style={{ fontSize: 14, color: "#701B8C" }}>
                    {"  R$ "}
                    {parseFloat(this.state.faturamento.total_estabelecimento)
                      .toFixed(2)
                      .replace(".", ",")}
                  </span>
                </p>
              </div>
            ) : null}
          </Col>
        </Row>
        <br />
        <TBLRelatorio data={this.state.data} numRows={10} loading={this.state.loading} />
      </div>
    );
  }
}
